import { httpClient } from "../http/httpClient";

export type HandleLeadStatusResponse = {
  success: boolean;
};

export interface HandleLeadStatusParams {
  id: string;
}

export async function handleLeadStatus({ id }: HandleLeadStatusParams) {
  const { data } = await httpClient
    .patch<HandleLeadStatusResponse>(`/lead/${id}`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
